import React from "react";

export default () => (
  <section>
    <h2>About Susan Rainwater</h2>
    <p>
      As your wedding or commitment ceremony may be one of the most important
      days of your life, I believe it’s very important to feel comfortable and
      at ease with your officiant.
    </p>
    <ul>
      <li>
        Passionate about social justice and ensure that others feel comfortable
        and respected at all times
      </li>
      <li>
        Truly enjoy planning an individualized ceremony and hope that the couple
        is able to have a ceremony exactly as they envision
      </li>
      <li>
        Believe that weddings and commitment ceremonies should be fun, elegant,
        and memorable
      </li>
    </ul>
    <p>Spiritual/Belief Background:</p>
    <ul>
      <li>
        I believe that all religions and faith backgrounds are to be respected,
        in such that one’s practices do not harm others
      </li>
      <li>Ordained through the Universal Life Church Monastery</li>
      <li>Raised in a Roman Catholic household</li>
      <li>Passionate about learning from religious and spiritual beliefs</li>
    </ul>
    <p>Experience:</p>
    <ul>
      <li>
        Wrote and prepared my own wedding ceremony service and incorporated
        other wedding traditions
      </li>
      <li>
        Knowledge in hand-fasting, unity candles/sand/water, jumping the broom,
        breaking of the glass, and other cultural wedding rituals and practices
      </li>
    </ul>
    <p>Personal Passions:</p>
    <ul>
      <li>Enjoy spending time with family and friends</li>
      <li>Love and appreciate nature</li>
      <li>Like to go hiking, rafting, and exploring new places</li>
      <li>
        Believe all animals should be respected and honored. I have rescued two
        cats from local animal control shelters and wish I could adopt more
      </li>
    </ul>
    <p>Education:</p>
    <ul>
      <li>Registered Counselor with the State of Washington</li>
      <li>
        Master’s degree in Clinical Social Work from the University of
        Washington
      </li>
      <li>
        Bachelor’s degree in Sociology and Criminal Justice from Gonzaga
        University
      </li>
    </ul>
  </section>
);
